module.exports = __webpack_public_path__ + "static/media/icon-empenhos.9c384c12.svg";